module.exports = __webpack_public_path__ + "static/assets/1b6b4f4aa0d2d84029a25dc5e76c3594.png";